// src/business-types/saloon/modules/orders/saloon-order-display/hooks/usePaymentHandler.ts
import { useState } from "react";
import { toast } from "react-toastify";
import { PaymentData } from "../../types/order";
import { clearPaymentInput, handlePaymentInputChange as handleChange } from "../utils/orderUtils";
import { processPaymentRequest } from "./orderHandler";

export const usePaymentHandler = (orderid?: string, order?: any, outstandingAmount?: number, fetchOrderDetails?: () => Promise<void>) => {
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const [paymentData, setPaymentData] = useState<PaymentData>({
    discount: "0",
    ReceivedAmount: "",
    paymentMethod: "cash",
  });

  const processPayment = async () => {
    if (!orderid || !order) return;
    setIsProcessing(true);

    try {
      // ✅ Fix: Ensure outstandingAmount is always a number
      await processPaymentRequest(orderid, order, paymentData);

      toast.success("Payment processed successfully", { autoClose: 1000 });
      setOpenPaymentDialog(false);
      setPaymentData(clearPaymentInput());

      await fetchOrderDetails?.();
    } catch (error) {
      console.error("Error processing payment:", error);
      toast.error(error instanceof Error ? error.message : "Payment processing failed");
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    paymentData,
    openPaymentDialog,
    setOpenPaymentDialog,
    isProcessing,
    handlePaymentInputChange: (e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, order, setPaymentData),
    processPayment,
    openPaymentWithMethod: (method?: string) => {
      const remaining = String(order?.orders?.[0]?.remainingAmount ?? order?.orders?.[0]?.orderAmount ?? "0");
      setPaymentData((prev) => ({
        ...prev,
        paymentMethod: method || prev.paymentMethod || "cash",
        ReceivedAmount: method === "buy on credit" ? "0" : (prev.ReceivedAmount || remaining),
      }));
      setOpenPaymentDialog(true);
    },
    resetPaymentData: () => {
      setPaymentData(clearPaymentInput());
      setOpenPaymentDialog(false);
    },
  };
};
